import React, { useEffect, useState } from 'react'
import { CashJournalValues, JournalVariation } from '../CashJournalWrapper/Types'
import { Stack, Box, Text } from '@chakra-ui/react'
import { buildMoneyFormat } from '../../utils/optionBuilders'

const getSectionTitle = (type: JournalVariation): string => {
  switch (type) {
    case JournalVariation.iraToIra:
      return 'Reason'
    case JournalVariation.iraToInd:
      return 'Distribution Details'
    case JournalVariation.indToIra:
      return 'Contribution Details'
    default:
      return ' '
  }
}

interface Props {
  formVariation?: JournalVariation
  formikValues: CashJournalValues
}
export const TransferTypeDetails = ({ formVariation, formikValues }: Props) => {
  const [sectionTitle, setSectionTitle] = useState<string>()

  const { indToIra, iraToInd, iraToIra } = JournalVariation

  useEffect(() => {
    if (formVariation) {
      const title = getSectionTitle(formVariation)
      setSectionTitle(title)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formVariation])

  return (
    <Stack spacing={6}>
      <Text as='h3' textStyle='h3' className='test-id-type-title'>
        {sectionTitle}
      </Text>
      <Stack spacing={6}>
        {/* indToInd this component should not show */}

        {indToIra === formVariation && (
          <>
            <Box className='test-id-indToIra'>
              <Text fontWeight='bold' className='label test-id-contribution-type-label'>
                Contribution Type
              </Text>
              <Text className='test-id-contribution-type'>{formikValues.contributionType}</Text>
            </Box>

            <Stack direction='row' w='100%' spacing={4}>
              <Box>
                <Text fontWeight='bold' className='label test-id-contribution-year-label'>
                  Contribution Year
                </Text>
                <Text className='test-id-contribution-year'>
                  {formikValues.contributionYear === 'PREVIOUS' ? 'Previous Year' : 'Current Year'}
                </Text>
              </Box>
            </Stack>
          </>
        )}

        {(iraToInd === formVariation || iraToIra === formVariation) && (
          <>
            <Box className='test-id-iraToInd'>
              <Text fontWeight='bold' className='label test-id-distribution'>
                Distribution Reason
              </Text>
              <Text className='test-id-distribution-reason'>{formikValues.distributionReason}</Text>
            </Box>
            {formikValues.federalTaxWithholdingType && (
              <Stack direction='row' w='100%' spacing={4}>
                <Box w='50%'>
                  <Text fontWeight='bold' className='label test-id-fed-tax-label'>
                    Federal Tax Withholding Type
                  </Text>
                  <Text className='test-id-fed-tax-value'>{formikValues.federalTaxWithholdingType}</Text>
                </Box>
                <Box w='50%'>
                  <Text fontWeight='bold' className='label test-id-fed-tax-amount-label'>
                    Federal Tax Withholding Amount
                  </Text>
                  <Text className='test-id-fed-tax-amount-total'>
                    {formikValues.federalTaxWithholdingType === 'PERCENTAGE'
                      ? `${formikValues.federalTaxWithholdingAmountDisplay || '0'}%`
                      : buildMoneyFormat(formikValues.federalTaxWithholdingAmountDisplay!)}
                  </Text>
                </Box>
              </Stack>
            )}
            {formikValues.stateTaxWithholdingType && (
              <Stack direction='row' w='100%' spacing={4}>
                <Box w='50%'>
                  <Text fontWeight='bold' className='label test-id-state-tax-label'>
                    State Tax Withholding Type
                  </Text>
                  <Text className='test-id-state-tax-value'>{formikValues.stateTaxWithholdingType}</Text>
                </Box>
                <Box w='50%'>
                  <Text fontWeight='bold' className='label test-id-state-tax-amount-label'>
                    State Tax Withholding Amount
                  </Text>
                  <Text className='test-id-state-tax-amount-total'>
                    {formikValues.stateTaxWithholdingType === 'PERCENTAGE'
                      ? `${formikValues.stateTaxWithholdingAmountDisplay || '0'}%`
                      : buildMoneyFormat(formikValues.stateTaxWithholdingAmountDisplay!)}
                  </Text>
                </Box>
              </Stack>
            )}
          </>
        )}

        {iraToIra === formVariation && (
          <Box>
            <Text fontWeight='bold' className='label test-id-contribution'>
              Contribution Reason
            </Text>
            <Text className='test-id-contribution-reason'>{formikValues.contributionReason}</Text>
          </Box>
        )}
      </Stack>
    </Stack>
  )
}
